export const FIND_MAIL_TEMPLATE_FAILURE = 'FIND_MAIL_TEMPLATE_FAILURE';

export const findMailTemplateFailure = error => ({
    type: FIND_MAIL_TEMPLATE_FAILURE,
    payload: error,
    error: true,
});
